import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getMyValentinePages } from '../lib/supabase';
import toast from 'react-hot-toast';

interface ValentinePage {
  id: string;
  sender: string;
  receiver: string;
  message: string;
  package_type: string;
  spotify_title: string;
  spotify_artist: string;
  is_approved: boolean;
  created_at: string;
}

export default function MyValentines() {
  const [pages, setPages] = useState<ValentinePage[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadPages() {
      try {
        const { data } = await getMyValentinePages();
        setPages(data || []);
      } catch (error) {
        toast.error('Failed to load Valentine pages');
      } finally {
        setLoading(false);
      }
    }

    loadPages();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">My Valentine Pages</h1>
      {pages.length === 0 ? (
        <p className="text-center text-gray-600">
          You haven't created any Valentine pages yet.
        </p>
      ) : (
        <div className="space-y-6">
          {pages.map((page) => (
            <div
              key={page.id}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="flex justify-between items-start mb-4">
                <div>
                  <h2 className="text-xl font-semibold">
                    To: {page.receiver}
                  </h2>
                  <p className="text-gray-600">From: {page.sender}</p>
                </div>
                <span
                  className={`px-3 py-1 rounded-full text-sm ${
                    page.is_approved
                      ? 'bg-green-100 text-green-800'
                      : 'bg-yellow-100 text-yellow-800'
                  }`}
                >
                  {page.is_approved ? 'Approved' : 'Pending'}
                </span>
              </div>
              <p className="text-gray-700 mb-4">{page.message}</p>
              <div className="text-sm text-gray-600">
                <p>Package: {page.package_type}</p>
                <p>
                  Song: {page.spotify_title} by {page.spotify_artist}
                </p>
              </div>
              {page.is_approved && (
                <div className="mt-4 space-y-2">
                  <Link
                    to={`/valentine/${page.id}`}
                    className="text-pink-600 hover:text-pink-700 font-medium block"
                  >
                    View Valentine Page →
                  </Link>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(`${window.location.origin}/valentine/${page.id}`);
                      toast.success('Link copied to clipboard!');
                    }}
                    className="text-sm text-gray-600 hover:text-gray-800"
                  >
                    Copy Sharing Link
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}